<template>
  <main>
    <!-- Hero section -->
    <div
      class="relative bg-cover bg-center"
      :style="{
        backgroundImage: `url(${require('../assets/images/mshelgroup.jpg')})`,
      }"
    >
      <div class="absolute inset-0 bg-black bg-opacity-50"></div>
      <div
        class="relative md:px-12 sm:px-12 px-2 max-w-screen-2xl mx-auto z-10 h-[30vh] lg:h-[60vh] flex items-center justify-start text-white"
      >
        <!-- BUM effect Section -->
        <h1
          class="text-4xl md:text-6xl px-4 lg:px-1 font-bold animate__animated animate__backInLeft"
        >
          About Mshel Group
        </h1>
      </div>

      <!-- Sleek Arch SVG Curve -->
      <svg
        class="absolute bottom-0 left-0 w-full"
        viewBox="0 0 1440 100"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill="#ffffff"
          d="M0,0 C480,100 960,100 1440,0 L1440,100 L0,100 Z"
        />
      </svg>
    </div>

    <!-- Welcome to the success story of Mshel Homes -->
    <div class="bg-white">
      <div class="md:px-12 max-w-screen-2xl mx-auto py-4 mb-10">
        <h1 class="text-center text-lg font-extrabold mt-4 px-2 lg:px-1">
          Welcome to the Success Story <br />
          of Mshel Group
        </h1>
        <p class="text-center text-2xl mt-2 px-2 lg:px-1">
          Discover the diverse and innovative subsidiaries that make up The
          <br />
          Mshel Group, each committed to excellence across real estate,
          hospitality, construction and social impact.
        </p>
      </div>
    </div>

    <!-- Mshel Group Subsidiaries section -->
    <div class="md:px-12 max-w-screen-3xl mx-auto bg-white py-16 -mt-10">
      <div
        class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8 cursor-pointer px-4 lg:px-1"
      >
        <!-- Card Template -->
        <div
          class="bg-white shadow-lg rounded-2xl p-6 hover:shadow-2xl transition-all duration-300"
        >
          <div
            class="flex items-center justify-center h-16 w-16 rounded-full bg-blue text-blue mb-4"
          >
            <img src="../assets/images/menu (1).png" class="w-8 h-8 filter invert"/>
          </div>
          <h3 class="text-xl font-semibold text-gray-800 h-10">Mshel Homes</h3>
          <p class="text-sm text-gray-500 mt-2 mb-4 h-12">
            Your trusted partner in modern, affordable housing solutions.
          </p>
          
          <div class="flex items-center justify-between">
            <div class="flex space-x-4 mb-4 mt-4">
              <div class="bg-blue p-2 rounded-full w-6 h-6 flex items-center justify-center">
                <a
                  href="https://www.facebook.com/MshelHomes/"
                  target="_blank"
                  class="text-white transition-all duration-300"
                  ><i class="fa-brands fa-facebook-f text-xs"></i
                ></a>
              </div>
              <div class="bg-blue p-2 rounded-full w-6 h-6 flex items-center justify-center">
                <a
                  href="https://www.instagram.com/mshelhomes/"
                  target="_blank"
                  class="text-white transition-all duration-300"
                  ><i class="fa-brands fa-instagram text-xs"></i
                ></a>
              </div>
              <div class="bg-blue p-2 rounded-full w-6 h-6 flex items-center justify-center">
                <a
                  href="https://www.youtube.com/@mshelhomes"
                  target="_blank"
                  class="text-white transition-all duration-300"
                  ><i class="fa-brands fa-youtube text-xs"></i
                ></a>
              </div>
              <div class="bg-blue p-2 rounded-full w-6 h-6 flex items-center justify-center">
                <a
                  href="https://www.linkedin.com/company/mshel-homes-limited"
                  target="_blank"
                  class="text-white transition-all duration-300"
                  ><i class="fa-brands fa-linkedin-in text-xs"></i
                ></a>
              </div>
            </div>
            <div>
              <a href="https://www.mshelhomes.com" target="_blank" class="text-blue transition-all duration-300"><i class="fa-solid fa-ellipsis-vertical"></i></a>
            </div>
          </div>
          <!-- <router-link to="/mshel-group/mshel-homes" class="text-sm font-medium text-blue hover:underline">
            View More
          </router-link> -->
        </div>

        <!-- Repeat cards with relevant data -->
        <div
          class="bg-white shadow-lg rounded-2xl p-6 hover:shadow-2xl transition-all duration-300"
        >
          <div
            class="flex items-center justify-center h-16 w-16 rounded-full bg-green-400 text-400 mb-4"
          >
          <img src="../assets/images/database.png" class="w-8 h-8 filter invert"/>
          </div>
          <h3 class="text-xl font-semibold text-gray-800 h-10 leading-tight">
            Mshel Blocks & Machineries
          </h3>
          <p class="text-sm text-gray-500 mt-2 mb-4 h-12">
            Producers of high-quality blocks and industrial-grade machines.
          </p>
          <div class="flex items-center justify-between">
            <div class="flex space-x-4 mb-4 mt-4">
              <div class="bg-green-400 p-2 rounded-full w-6 h-6 flex items-center justify-center">
                <a
                  href="https://www.facebook.com/barmshel?mibextid=LQQJ4d"
                  target="_blank"
                  class="text-white transition-all duration-300"
                  ><i class="fa-brands fa-facebook-f text-xs"></i
                ></a>
              </div>
              <div class="bg-green-400 p-2 rounded-full w-6 h-6 flex items-center justify-center">
                <a
                  href="https://www.instagram.com/barkaumshelia?igsh=MW0xcDdrbmg1dnNpaQ%3D%3D&utm_source=qr"
                  target="_blank"
                  class="text-white transition-all duration-300"
                  ><i class="fa-brands fa-instagram text-xs"></i
                ></a>
              </div>
              <div class="bg-green-400 p-2 rounded-full w-6 h-6 flex items-center justify-center">
                <a
                  href="https://youtube.com/@barkamshelia?si=LMpUZmOfBcS_DD9P"
                  target="_blank"
                  class="text-white transition-all duration-300"
                  ><i class="fa-brands fa-youtube text-xs"></i
                ></a>
              </div>
              <div class="bg-green-400 p-2 rounded-full w-6 h-6 flex items-center justify-center">
                <a
                  href="https://www.linkedin.com/in/barka-mshelia-408232102?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app"
                  target="_blank"
                  class="text-white transition-all duration-300"
                  ><i class="fa-brands fa-linkedin-in text-xs"></i
                ></a>
              </div>
            </div>
            <div>
              <a href="" class="text-green-400 transition-all duration-300"><i class="fa-solid fa-ellipsis-vertical"></i></a>
            </div>
          </div>
        </div>

        <div
          class="bg-white shadow-lg rounded-2xl p-6 hover:shadow-2xl transition-all duration-300"
        >
          <div
            class="flex items-center justify-center h-16 w-16 rounded-full bg-pink-400 text-pink-400 mb-4"
          >
          <img src="../assets/images/edit.png" class="w-8 h-8 filter invert"/>
          </div>
          <h3 class="text-xl font-semibold text-gray-800 h-10">Mshel Prints</h3>
          <p class="text-sm text-gray-500 mt-2 mb-4 h-12">
            Innovative printing solutions for your branding and needs.
          </p>
          <div class="flex items-center justify-between">
            <div class="flex space-x-4 mb-4 mt-4">
              <div class="bg-pink-400 p-2 rounded-full w-6 h-6 flex items-center justify-center">
                <a
                  href="https://www.facebook.com/barmshel?mibextid=LQQJ4d"
                  target="_blank"
                  class="text-white transition-all duration-300"
                  ><i class="fa-brands fa-facebook-f text-xs"></i
                ></a>
              </div>
              <div class="bg-pink-400 p-2 rounded-full w-6 h-6 flex items-center justify-center">
                <a
                  href="https://www.instagram.com/barkaumshelia?igsh=MW0xcDdrbmg1dnNpaQ%3D%3D&utm_source=qr"
                  target="_blank"
                  class="text-white transition-all duration-300"
                  ><i class="fa-brands fa-instagram text-xs"></i
                ></a>
              </div>
              <div class="bg-pink-400 p-2 rounded-full w-6 h-6 flex items-center justify-center">
                <a
                  href="https://youtube.com/@barkamshelia?si=LMpUZmOfBcS_DD9P"
                  target="_blank"
                  class="text-white transition-all duration-300"
                  ><i class="fa-brands fa-youtube text-xs"></i
                ></a>
              </div>
              <div class="bg-pink-400 p-2 rounded-full w-6 h-6 flex items-center justify-center">
                <a
                  href="https://www.linkedin.com/in/barka-mshelia-408232102?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app"
                  target="_blank"
                  class="text-white transition-all duration-300"
                  ><i class="fa-brands fa-linkedin-in text-xs"></i
                ></a>
              </div>
            </div>
            <div>
              <a href="" class="text-pink-400 transition-all duration-300"><i class="fa-solid fa-ellipsis-vertical"></i></a>
            </div>
          </div>
        </div>

        <div
          class="bg-white shadow-lg rounded-2xl p-6 hover:shadow-2xl transition-all duration-300"
        >
          <div
            class="flex items-center justify-center h-16 w-16 rounded-full bg-yellow-400 text-yellow-400 mb-4"
          >
          <img src="../assets/images/unlocked.png" class="w-8 h-8 filter invert"/>
          </div>
          <h3 class="text-xl font-semibold text-gray-800 h-10">Mshel Consult</h3>
          <p class="text-sm text-gray-500 mt-2 mb-4 h-12">
            Expert business consulting tailored for sustainable growth.
          </p>
          <div class="flex items-center justify-between">
            <div class="flex space-x-4 mb-4 mt-4">
              <div class="bg-yellow-400 p-2 rounded-full w-6 h-6 flex items-center justify-center">
                <a
                  href="https://www.facebook.com/barmshel?mibextid=LQQJ4d"
                  target="_blank"
                  class="text-white transition-all duration-300"
                  ><i class="fa-brands fa-facebook-f text-xs"></i
                ></a>
              </div>
              <div class="bg-yellow-400 p-2 rounded-full w-6 h-6 flex items-center justify-center">
                <a
                  href="https://www.instagram.com/barkaumshelia?igsh=MW0xcDdrbmg1dnNpaQ%3D%3D&utm_source=qr"
                  target="_blank"
                  class="text-white transition-all duration-300"
                  ><i class="fa-brands fa-instagram text-xs"></i
                ></a>
              </div>
              <div class="bg-yellow-400 p-2 rounded-full w-6 h-6 flex items-center justify-center">
                <a
                  href="https://youtube.com/@barkamshelia?si=LMpUZmOfBcS_DD9P"
                  target="_blank"
                  class="text-white transition-all duration-300"
                  ><i class="fa-brands fa-youtube text-xs"></i
                ></a>
              </div>
              <div class="bg-yellow-400 p-2 rounded-full w-6 h-6 flex items-center justify-center">
                <a
                  href="https://www.linkedin.com/in/barka-mshelia-408232102?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app"
                  target="_blank"
                  class="text-white transition-all duration-300"
                  ><i class="fa-brands fa-linkedin-in text-xs"></i
                ></a>
              </div>
            </div>
            <div>
              <a href="" class="text-yellow-400 transition-all duration-300"><i class="fa-solid fa-ellipsis-vertical"></i></a>
            </div>
          </div>
        </div>

        <div
          class="bg-white shadow-lg rounded-2xl p-6 hover:shadow-2xl transition-all duration-300"
        >
          <div
            class="flex items-center justify-center h-16 w-16 rounded-full bg-purple-400 text-purple-400 mb-4"
          >
          <img src="../assets/images/blocks.png" class="w-8 h-8 filter invert"/>
          </div>
          <h3 class="text-xl font-semibold text-gray-800 h-10">Mshel Foundation</h3>
          <p class="text-sm text-gray-500 mt-2 mb-4 h-12">
            Empowering lives through impactful social initiatives.
          </p>
          <div class="flex items-center justify-between">
            <div class="flex space-x-4 mb-4 mt-4">
              <div class="bg-purple-400 p-2 rounded-full w-6 h-6 flex items-center justify-center">
                <a
                  href="https://www.facebook.com/barmshel?mibextid=LQQJ4d"
                  target="_blank"
                  class="text-white transition-all duration-300"
                  ><i class="fa-brands fa-facebook-f text-xs"></i
                ></a>
              </div>
              <div class="bg-purple-400 p-2 rounded-full w-6 h-6 flex items-center justify-center">
                <a
                  href="https://www.instagram.com/barkaumshelia?igsh=MW0xcDdrbmg1dnNpaQ%3D%3D&utm_source=qr"
                  target="_blank"
                  class="text-white transition-all duration-300"
                  ><i class="fa-brands fa-instagram text-xs"></i
                ></a>
              </div>
              <div class="bg-purple-400 p-2 rounded-full w-6 h-6 flex items-center justify-center">
                <a
                  href="https://youtube.com/@barkamshelia?si=LMpUZmOfBcS_DD9P"
                  target="_blank"
                  class="text-white transition-all duration-300"
                  ><i class="fa-brands fa-youtube text-xs"></i
                ></a>
              </div>
              <div class="bg-purple-400 p-2 rounded-full w-6 h-6 flex items-center justify-center">
                <a
                  href="https://www.linkedin.com/in/barka-mshelia-408232102?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app"
                  target="_blank"
                  class="text-white transition-all duration-300"
                  ><i class="fa-brands fa-linkedin-in text-xs"></i
                ></a>
              </div>
            </div>
            <div>
              <a href="" class="text-purple-400 transition-all duration-300"><i class="fa-solid fa-ellipsis-vertical"></i></a>
            </div>
          </div>
        </div>

        <div
          class="bg-white shadow-lg rounded-2xl p-6 hover:shadow-2xl transition-all duration-300"
        >
          <div
            class="flex items-center justify-center h-16 w-16 rounded-full bg-red-400 text-red-400 mb-4"
          >
          <img src="../assets/images/accomodation.png" class="w-8 h-8 filter invert"/>
          </div>
          <h3 class="text-xl font-semibold text-gray-800 h-10">Lisa Suites</h3>
          <p class="text-sm text-gray-500 mt-2 mb-4 h-12">
            A luxurious hospitality experience in the heart of the city.
          </p>
          <div class="flex items-center justify-between">
            <div class="flex space-x-4 mb-4 mt-4">
              <div class="bg-red-400 p-2 rounded-full w-6 h-6 flex items-center justify-center">
                <a
                  href="https://www.facebook.com/lisasuites"
                  target="_blank"
                  class="text-white transition-all duration-300"
                  ><i class="fa-brands fa-facebook-f text-xs"></i
                ></a>
              </div>
              <div class="bg-red-400 p-2 rounded-full w-6 h-6 flex items-center justify-center">
                <a
                  href="https://www.instagram.com/lisasuites"
                  target="_blank"
                  class="text-white transition-all duration-300"
                  ><i class="fa-brands fa-instagram text-xs"></i
                ></a>
              </div>
              <div class="bg-red-400 p-2 rounded-full w-6 h-6 flex items-center justify-center">
                <a
                  href="https://youtube.com/@lisasuites"
                  target="_blank"
                  class="text-white transition-all duration-300"
                  ><i class="fa-brands fa-youtube text-xs"></i
                ></a>
              </div>
              <div class="bg-red-400 p-2 rounded-full w-6 h-6 flex items-center justify-center">
                <a
                  href="https://www.linkedin.com/in/lisa-suites"
                  target="_blank"
                  class="text-white transition-all duration-300"
                  ><i class="fa-brands fa-linkedin-in text-xs"></i
                ></a>
              </div>
            </div>
            <div>
              <a href="https://www.lisasuites.com" class="text-red-400 transition-all duration-300"><i class="fa-solid fa-ellipsis-vertical"></i></a>
            </div>
          </div>
        </div>

        <div
          class="bg-white shadow-lg rounded-2xl p-6 hover:shadow-2xl transition-all duration-300"
        >
          <div
            class="flex items-center justify-center h-16 w-16 rounded-full bg-indigo-400 text-indigo-400 mb-4"
          >
          <img src="../assets/images/logistics.png" class="w-8 h-8 filter invert"/>
          </div>
          <h3 class="text-xl font-semibold text-gray-800 h-10">Mshel Logistics</h3>
          <p class="text-sm text-gray-500 mt-2 mb-4 h-12">
            Fast and reliable logistics solutions tailored to your needs.
          </p>
          <div class="flex items-center justify-between">
            <div class="flex space-x-4 mb-4 mt-4">
              <div class="bg-indigo-400 p-2 rounded-full w-6 h-6 flex items-center justify-center">
                <a
                  href="https://www.facebook.com/barmshel?mibextid=LQQJ4d"
                  target="_blank"
                  class="text-white transition-all duration-300"
                  ><i class="fa-brands fa-facebook-f text-xs"></i
                ></a>
              </div>
              <div class="bg-indigo-400 p-2 rounded-full w-6 h-6 flex items-center justify-center">
                <a
                  href="https://www.instagram.com/barkaumshelia?igsh=MW0xcDdrbmg1dnNpaQ%3D%3D&utm_source=qr"
                  target="_blank"
                  class="text-white transition-all duration-300"
                  ><i class="fa-brands fa-instagram text-xs"></i
                ></a>
              </div>
              <div class="bg-indigo-400 p-2 rounded-full w-6 h-6 flex items-center justify-center">
                <a
                  href="https://youtube.com/@barkamshelia?si=LMpUZmOfBcS_DD9P"
                  target="_blank"
                  class="text-white transition-all duration-300"
                  ><i class="fa-brands fa-youtube text-xs"></i
                ></a>
              </div>
              <div class="bg-indigo-400 p-2 rounded-full w-6 h-6 flex items-center justify-center">
                <a
                  href="https://www.linkedin.com/in/barka-mshelia-408232102?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app"
                  target="_blank"
                  class="text-white transition-all duration-300"
                  ><i class="fa-brands fa-linkedin-in text-xs"></i
                ></a>
              </div>
            </div>
            <div>
              <a href="" class="text-indigo-400 transition-all duration-300"><i class="fa-solid fa-ellipsis-vertical"></i></a>
            </div>
          </div>
        </div>

        <div
          class="bg-white shadow-lg rounded-2xl p-6 hover:shadow-2xl transition-all duration-300"
        >
          <div
            class="flex items-center justify-center h-16 w-16 rounded-full bg-teal-400 text-teal-400 mb-4"
          >
          <img src="../assets/images/construction.png" class="w-8 h-8 filter invert"/>
          </div>
          <h3 class="text-xl font-semibold text-gray-800 h-10">
            Mshel Construction
          </h3>
          <p class="text-sm text-gray-500 mt-2 mb-4 h-12">
            Building world-class infrastructure and engineering excellence.
          </p>
          <div class="flex items-center justify-between">
            <div class="flex space-x-4 mb-4 mt-4">
              <div class="bg-teal-400 p-2 rounded-full w-6 h-6 flex items-center justify-center">
                <a
                  href="https://www.facebook.com/mshelconstruction"
                  target="_blank"
                  class="text-white transition-all duration-300"
                  ><i class="fa-brands fa-facebook-f text-xs"></i
                ></a>
              </div>
              <div class="bg-teal-400 p-2 rounded-full w-6 h-6 flex items-center justify-center">
                <a
                  href="https://www.instagram.com/mshelconstruction"
                  target="_blank"
                  class="text-white transition-all duration-300"
                  ><i class="fa-brands fa-instagram text-xs"></i
                ></a>
              </div>
              <div class="bg-teal-400 p-2 rounded-full w-6 h-6 flex items-center justify-center">
                <a
                  href="https://youtube.com/@mshelconstruction"
                  target="_blank"
                  class="text-white transition-all duration-300"
                  ><i class="fa-brands fa-youtube text-xs"></i
                ></a>
              </div>
              <div class="bg-teal-400 p-2 rounded-full w-6 h-6 flex items-center justify-center">
                <a
                  href="https://www.linkedin.com/in/mshel-construction"
                  target="_blank"
                  class="text-white transition-all duration-300"
                  ><i class="fa-brands fa-linkedin-in text-xs"></i
                ></a>
              </div>
            </div>
            <div>
              <a href="https://www.mshelconstruction.com" target="_blank" class="text-teal-400 transition-all duration-300"><i class="fa-solid fa-ellipsis-vertical"></i></a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Building Community -->
     <mshelHomes />

     <!-- Mshel Club -->
      <div class="bg-main">
        <div class="md:px-12 max-w-screen-2xl mx-auto">
         <div class="flex flex-col lg:flex-row gap-10 items-center px-4 lg:px-1">
           <div class="lg:w-1/2 mt-14 mb-8">
             <p class="text-2xl mt-5 text-white">
               Ready to transform yourself or your organization to unlock new
               possibilities and create opportunities for success?
             </p>
             <!-- CTA Button -->
             <div class="flex items-center justify-start">
               <router-link
                 to="/mshel-club"
                 class="bg-blue rounded-lg text-white px-6 py-2 transition mt-6"
               >
                 ➔ Join Mshel Club
               </router-link>
             </div>
           </div>
   
           <div class="lg:w-1/2 mt-14 mb-8">
             <img
               src="../assets/images/about-barka.jpeg"
               alt="About Barka U. Mshelia"
               class="w-full h-1/4 object-cover rounded-2xl"
             />
           </div>
         </div>
       </div>
      </div>
  </main>
</template>

<script>
import mshelHomes from "../components/mshelHomes.vue";

export default {
components: {
  mshelHomes
}
};
</script>

<style scoped>
svg path {
  fill: #fff !important;
  stroke: none !important;
  box-shadow: none !important;
}

svg {
  overflow: hidden !important;
}

.absolute.bottom-0 {
  line-height: 0 !important;
  padding-bottom: 0 !important;
  margin-bottom: -2px;
}

.overflow-hidden {
  overflow: hidden !important;
}
</style>
